import React from "react";

export function KpiCard({ label, value, sublabel, tone = "default", icon: Icon, testid }) {
  const toneClass = {
    default: "text-foreground",
    success: "text-emerald-700",
    warn: "text-amber-700",
    danger: "text-rose-700",
  }[tone];
  return (
    <div className="rounded-xl border border-border bg-card p-5 hover:shadow-sm transition" data-testid={testid}>
      <div className="flex items-center justify-between">
        <div className="text-xs font-bold uppercase tracking-[0.18em] text-muted-foreground">{label}</div>
        {Icon && <Icon className="h-4 w-4 text-muted-foreground" />}
      </div>
      <div className={`mt-3 font-display text-3xl sm:text-4xl tracking-tight font-bold ${toneClass}`}>{value}</div>
      {sublabel && <div className="mt-1 text-sm text-muted-foreground">{sublabel}</div>}
    </div>
  );
}
